export const COMMON = {
  button: {
    save: 'Save',
    archive: 'Archive',
    delete: 'Delete',
    back: 'Back',
    cancel: 'Cancel'
  }
};
